import { Satellite, Save } from "lucide-react";
import { Modal, modalBtnPrimary, modalBtnSecondary } from "../Modal";
import { fmtKc } from "../../lib/format";

export const inputCls = "w-full min-h-[44px] px-3 py-2 border border-slate-300 bg-white text-sm rounded-sm focus:outline-none focus:ring-2 focus:ring-orange-600";


export function Field({ label, v, on, type = "text", testid, step, inputMode, placeholder }) {
    return (
        <div>
            <label className="label-eyebrow block mb-1.5">{label}</label>
            <input type={type} value={v ?? ""} onChange={on} data-testid={testid} step={step} inputMode={inputMode} placeholder={placeholder} className={inputCls} />
        </div>
    );
}

export function TripForm({ editing, setEditing, onSave, onClose, jobs, vehicles, money, craftsman }) {
    const set = (k) => (e) => setEditing({ ...editing, [k]: e.target.value });
    const setOdoStart = (e) => {
        const v = e.target.value;
        const end = v !== "" && editing.km ? String(Math.round((Number(v) + Number(editing.km)) * 10) / 10) : editing.odometer_end;
        setEditing({ ...editing, odometer_start: v, odometer_end: end });
    };
    const title = editing.id ? "Upravit jízdu" : editing.source === "gps" ? "Uložit GPS jízdu" : "Nová jízda";
    return (
        <Modal title={title} onClose={onClose} testid="trip-modal"
               footer={<>
                   <button onClick={onClose} className={modalBtnSecondary} data-testid="trip-cancel">Zrušit</button>
                   <button onClick={onSave} className={modalBtnPrimary} data-testid="save-trip"><Save className="w-3.5 h-3.5" /> Uložit</button>
               </>}>
            <div className="space-y-4">
                {editing.source === "gps" && !editing.id && (
                    <div className="flex items-center gap-2 text-xs text-amber-800 bg-amber-50 border border-amber-300 px-3 py-2 rounded-sm" data-testid="gps-summary">
                        <Satellite className="w-3.5 h-3.5 shrink-0" /> Změřeno GPS: {editing.km || 0} km · {editing.duration_min} min · {editing.points_count} bodů · {editing.start_time}–{editing.end_time}. Doplňte vozidlo, účel a zakázku.
                    </div>
                )}
                <div>
                    <label className="label-eyebrow block mb-1.5">Vozidlo *</label>
                    <select value={editing.vehicle_id || ""} onChange={set("vehicle_id")} className={inputCls} data-testid="trip-vehicle">
                        <option value="">— vyberte vozidlo —</option>
                        {vehicles.map((v) => <option key={v.id} value={v.id}>{v.name}{v.plate ? ` (${v.plate})` : ""}</option>)}
                    </select>
                    {vehicles.length === 0 && <div className="text-[11px] text-red-600 mt-1">Žádné vozidlo – vlastník/administrátor je přidá v Nastavení firmy → Vozidla.</div>}
                </div>
                <div className="grid grid-cols-2 gap-3">
                    <Field label="Datum *" type="date" v={editing.date} on={set("date")} testid="trip-date" />
                    <div>
                        <label className="label-eyebrow block mb-1.5">Typ jízdy</label>
                        <select value={editing.trip_type || "sluzebni"} onChange={set("trip_type")} className={inputCls} data-testid="trip-type">
                            <option value="sluzebni">Služební</option><option value="soukroma">Soukromá</option>
                        </select>
                    </div>
                </div>
                <div className="grid grid-cols-2 gap-3">
                    <Field label="Čas od" type="time" v={editing.start_time} on={set("start_time")} testid="trip-start-time" />
                    <Field label="Čas do" type="time" v={editing.end_time} on={set("end_time")} testid="trip-end-time" />
                </div>
                <div className="grid grid-cols-2 gap-3">
                    <Field label="Odkud" v={editing.from_place} on={set("from_place")} testid="trip-from" />
                    <Field label="Kam" v={editing.to_place} on={set("to_place")} testid="trip-to" />
                </div>
                <div className="grid grid-cols-3 gap-3">
                    <Field label="Km *" type="number" inputMode="decimal" step="0.1" v={editing.km} on={set("km")} testid="trip-km" />
                    <Field label="Tachometr start" type="number" inputMode="numeric" v={editing.odometer_start} on={setOdoStart} testid="trip-odo-start" />
                    <Field label="Tachometr konec" type="number" inputMode="numeric" v={editing.odometer_end} on={set("odometer_end")} testid="trip-odo-end" />
                </div>
                {money && (
                    <div className="grid grid-cols-2 gap-3">
                        <Field label="Sazba Kč/km" type="number" inputMode="decimal" step="0.1" v={editing.rate_per_km} on={set("rate_per_km")} testid="trip-rate" />
                        <div>
                            <label className="label-eyebrow block mb-1.5">Částka</label>
                            <div className="min-h-[44px] px-3 py-2 border border-slate-200 bg-slate-50 text-sm font-semibold rounded-sm flex items-center" data-testid="trip-amount-preview">{fmtKc((Number(editing.km) || 0) * (Number(editing.rate_per_km) || 0))}</div>
                        </div>
                    </div>
                )}
                <div>
                    <label className="label-eyebrow block mb-1.5">Zakázka (volitelně)</label>
                    <select value={editing.job_id || ""} onChange={set("job_id")} className={inputCls} data-testid="trip-job">
                        <option value="">— Bez zakázky —</option>
                        {jobs.map((j) => <option key={j.id} value={j.id}>{j.title}</option>)}
                    </select>
                </div>
                <Field label="Účel jízdy" v={editing.purpose} on={set("purpose")} testid="trip-purpose" placeholder="např. doprava materiálu, kontrola stavby" />
                {!craftsman && <Field label="Řidič" v={editing.driver} on={set("driver")} testid="trip-driver" />}
            </div>
        </Modal>
    );
}
